<template minapp="mpx" xlang="wxml">
  <view class="train-rules">
    <view class="head">
      <view class="title">购买须知</view>
      <view class="customer-service">
        <image class="icon" src="{{arrow}}" />
        <view class="more-text" bindtap="toCustomerService">联系客服</view>
      </view>
    </view>
    <view class="con">
      <view wx:for="{{arrList}}" class="item" bindtap="jumpFn(item.url)">{{ item.title }}</view>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'
import store from '@/store'
import { innerRouter, pagePath } from '@/common/jump'
import { OrderStatus, TicketStatus } from '@/common/enum'
import { trackEvent } from '@/common/track'
import { is } from '@didi/spring-base'

createComponent({
  props: {
    order: {
      type: Object
    }
  },
  data: {
    arrList: [
      {
        title: '如何取纸质车票？',
        url: ''
      },
      {
        title: '如何进站乘车？',
        url: ''
      },
      {
        title: '为什么购票失败？',
        url: ''
      },
      {
        title: '退票时优惠券如何计算？',
        url: 'refund'
      },
      {
        title: '退票收手续费吗？',
        url: ''
      },
      {
        title: '更多问题',
        url: ''
      }
    ],
    arrow: 'https://ut-static.udache.com/webx/sfc/juzU55RSoZ16fQas6xva0.png'
  },
  computed: {
    ...store.mapState({
      baseInfo: 'order.base_info',
      state: 'order.base_info.status' // 订单状态
    }),
    order_type() {
      return this.baseInfo.order_type
    },
    scrambling() {
      return [OrderStatus.SCRAMBLING].includes(this.state) && this.order_type === 2
    },
    orderStatus() {
      return this.baseInfo.status_name
    },
    isSimplified() {
      let _flag1 =
        [
          OrderStatus.BOOKING,
          OrderStatus.OCCUPYING_SEAT,
          OrderStatus.CHANGE_OCCUPYING_SEAT,
          OrderStatus.SCRAMBLE_BOOKING
        ].includes(this.state) && this.baseInfo?.is_pay !== 1
      let _flag2 = [OrderStatus.SCRAMBLING].includes(this.state)
      return _flag1 || _flag2
    },
    trackEventPublicParams() {
      const { order_id } = this.$mpxRoute.query || {}
      return {
        order_id,
        status: this.orderStatus,
        login_type: this.baseInfo?.order_type === 1 ? 'quick' : '12306'
      }
    },
    // 占座已支付
    occupyingAndPayed() {
      return (
        [OrderStatus.OCCUPYING_SEAT, OrderStatus.CHANGE_OCCUPYING_SEAT].includes(this.state) &&
        this.baseInfo?.is_pay === 1
      )
    },
    showCustomerService() {
      if ([OrderStatus.ISSUIN, OrderStatus.ISSUING, OrderStatus.BOOKING].includes(this.state)) {
        return true
      }
      if (this.scrambling) {
        return true
      }
      return (
        this.baseInfo.show_customer_service_button && !this.isSimplified && !this.occupyingAndPayed
      )
    },
  },
  methods: {
     jumpFn(url) {
        innerRouter.push(pagePath().ICKETPURCHASENOTICE, { checkTabIndex: url })
      },
    toCustomerService() {
      const { order_id } = this.$mpxRoute.query || {}
      trackEvent('userteam_train_orderdetail_issued_ck', 'UT-火车票-订单详情-已出票-点击', {
        ...this.trackEventPublicParams,
        module: 'cus_service',
        ticket_id: ''
      })
      const source = is('passenger')
      ? 'app_ddcx_tohwd_im'
      : is('weixin')
        ? 'xcx_ddcx_paweq_im'
        : is('alipay')
          ? 'zfbxcx_ddcx_ngjel_im'
          : ''
      innerRouter.push(pagePath().HOMESERVICE, {
        order_id,
        actionType: 'help',
        orderId: order_id,
        source,
        from: this.from
      })
    }
  }
})
</script>

<style lang="stylus" scoped>
@import '~@/mixins/stylus/color.styl'

.train-rules
  background #FFFFFF
  border-radius 8px
  padding 14px
  margin-bottom 10px
.head
  display flex
  justify-content space-between
  .title
    font-family PingFangSC-Medium
    font-size 16px
    font-weight normal
    line-height 16px
    letter-spacing 0px
    color #333333
  .customer-service
    display flex
    align-items center
    .icon
      width 14px
      height 14px
      margin-right 4px
    .more-text
      font-family PingFangSC-Regular
      font-size 14px
      line-height 14px
      letter-spacing 0px
      color #999999
.con
  margin-top 6px
  .item
    display inline-block
    border-radius 6px
    box-sizing border-box
    position relative
    padding 8px
    font-family PingFangSC-Regular
    font-size 13px
    line-height 13px
    color #666666
    margin-right 5px
    margin-top 5px
    &::after
      position absolute
      content: ""
      width 200%
      height 200%
      box-sizing border-box
      border 1px solid #ccc
      transform-origin 0 0
      transform scale(0.5)
      border-radius 12px
      top 0
      left 0
</style>

<script name="json">
module.exports = {
  component: true
}
</script>